








import { defineComponent } from "vue";

export default defineComponent({
  computed: {
    title() {
      if (this.$route.name === "analise_cobertura.cobertura") {
        return "Análise de Cobertura – Exames";
      }
      return "Nova Análise";
    }
  }
});
